import React from "react";
import styles from "./logo.module.css";

const Logo = ({
  width,
  height,
  handleClick,
  cursor,
  warnerLogo,
}) => {
  const imgStyle = {
    width: width || 'auto',
    height: height || 'auto',
    cursor
  };

  return (
    <>
      {warnerLogo ? (
        <img
          src={"/img/logos/Warner_Logo_Blue.svg"}
          className={styles.logoImage}
          style={imgStyle}
          onClick={handleClick}
          alt="Warner Hotels"
        />
      ) : (
        <div
          className={styles.logoWrapper}
          style={{
            width: width || 'auto',
            height: height || 'auto'
          }}
        >
          <img
            src={"/img/logos/Warner_Logo_Blue.svg"}
            className={styles.logoImage}
            style={imgStyle}
            onClick={handleClick}
            alt="Warner Hotels"
          />
        </div>
      )}
    </>
  );
};

export default Logo;
